import { AsyncPageRender } from '@components/AsyncComponent';
import { createTabs } from '@packages/tabs';

export const TABS = createTabs([
    ['approved', 'Approved', AsyncPageRender(() => import('./Approved'))],
    // [ 'rejected', 'Rejected', AsyncPageRender(() => import('./Rejected')) ],
    ['archives', 'Archives', AsyncPageRender(() => import('./Archives'))],
    ['requests', 'Requests', AsyncPageRender(() => import('./Requests'))],
]);
